var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{staticClass:"d-flex",attrs:{"value":_vm.overlay.active,"color":"white","opacity":"0.75"}},[_c('Loading'),_c('h2',{staticClass:"black-color pa-2 py-7"},[_vm._v(_vm._s(_vm.$t(_vm.overlay.text)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }